export default {
  INACTIVE: -1,
  PENDING: 1,
  FAILED: 2,
  ESCALATED: 3,
  MITEK_API_FAIL: 4,
  SKIPPED: 5,
  SUCCESS: 6,
}